import type { ComponentProps } from 'react';

import { SkipBackIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';

import { useMedia } from '..';

export function SkipBackButton(skipBackButtonProps: ComponentProps<typeof Button>) {
  const { onClick, ...props } = skipBackButtonProps;
  const { skip } = useMedia();

  return (
    <Button
      size="sm"
      type={'button'}
      variant={'ghost'}
      onClick={(e) => {
        e.stopPropagation();
        skip(-10);
        onClick?.(e);
      }}
      {...props}
    >
      <SkipBackIcon />
    </Button>
  );
}
